module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-detail-bottom"
  }, [_c('div', {
    staticClass: "left"
  }, _vm._l((_vm.content), function(row, index) {
    return _c('rt-row', {
      key: index
    }, _vm._l((row.attrs), function(col, index2) {
      return _c('rt-col', {
        key: index2,
        attrs: {
          "span": col.span,
          "align": col.align
        }
      }, [_c('rt-attr', {
        attrs: {
          "label": col.label,
          "text": col.text,
          "light": col.light,
          "type": "primary"
        }
      })], 1)
    }), 1)
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21e98a94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/business/detail/rtDetailBottom.vue
// module id = 1472
// module chunks = 124